import { render, staticRenderFns } from "./TransactionNoteDialog.vue?vue&type=template&id=ebb9ef84&"
import script from "./TransactionNoteDialog.vue?vue&type=script&lang=js&"
export * from "./TransactionNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports